export{PromoBannerComponent}from"./promo-banner.component.js";
//# sourceMappingURL=index.js.map
